// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"1427":"8e70889b","1637":"5bda4a79","3207":"c18c4745","5678":"6a646919","9279":"de743f6a","9633":"98f979bd"}[chunkId] + ".js";
};